import React from "react";
import { Link } from "react-router-dom";
import company from "../lib/company.json";
import { SectionHeading, Arrow } from "./CampaignHero";
import { TeamIcon } from "./BrandIcons";

export const CompanyTeam = () => <section id="team" className="campaign-section" data-testid="company-team-section">
  <div className="campaign-container">
    <SectionHeading id="company-team" eyebrow="Leadership, advisors & partners" title="The right people around the table." body="Executive leadership, commercial development, governance and customer success. The people helping shape Helios Brain." />
    <div className="company-team-grid" data-testid="company-team-grid">
      {company.team.map((member, index) => <article key={member.id} data-testid={`team-card-${index}`} data-member={member.id}>
        <div className="team-role"><TeamIcon size={21} aria-hidden="true" /><span data-testid={`team-role-${member.id}`}>{member.role}</span></div>
        <h3 data-testid={`team-name-${member.id}`}>{member.name}</h3>
        <ul data-testid={`team-bio-${member.id}`}>{member.bullets.map(bullet => <li key={bullet}>{bullet}</li>)}</ul>
      </article>)}
    </div>
    <p className="campaign-small company-team-role-note" data-testid="company-team-role-note">Advisors are distinct from employees.</p>
    <Link className="campaign-text-link" to="/careers" data-testid="company-careers-link">Explore working with us<Arrow /></Link>
  </div>
</section>;